import { deliveryMethods } from '../constants'

export const getExchangeDeliveryMethod = deliveryMethod => ({
  ...deliveryMethod,
  requires_address: true,
  type: deliveryMethods.customerPickup,
})

export const getGiftRecipientAddress = orderInfo => ({
  first_name: orderInfo?.gift_recipient?.first_name || '',
  last_name: orderInfo?.gift_recipient?.last_name || '',
  company: null,
  line_1: '',
  house_number: null,
  line_2: '',
  postcode: '',
  locality: '',
  province: orderInfo?.shipping_address?.province,
  country: orderInfo?.shipping_address?.country,
  phone: {
    prefix: orderInfo?.shipping_address?.phone?.prefix || '',
    number: '',
  },
})

export const getShippingAddress = orderInfo => ({ ...orderInfo?.shipping_address })
